export const globalStyles = {
	title:
		"font-villula text-2xl font-normal leading-6 max-w-[310px] mb-4 mx-auto",
};
